import monolith from "@utils/fetch/fetches";
import {getFetchCareUrl} from "../getFetchCareUrl";
import {FetchCareEntryResponse} from "..";

export const fetchCareEntry = (slug: string): Promise<FetchCareEntryResponse> =>
  monolith()(getFetchCareUrl(slug)).then(res => res.json());
